<template>
  <div class="page-document-keywords">
    <BaseLoadingBar is-small v-if="pending && !keywords.length" />

    <div v-else-if="!pending && !keywords.length" class="document-keywords__no-keyword">
      <span v-if="isAdmin">{{ $t('page.admin-document-keywords.no-keyword') }}</span>
      <span v-else>{{ $t('page.analysis.keyword-navigator.no-keyword') }}</span>
    </div>

    <div v-else class="page-document-keywords__content">
      <DocumentKeywordsList v-for="(category, index) in keywords" :key="index" :category="category" />
    </div>
  </div>
</template>

<script>
import { isAdminTenant } from '@/models/role';
import { mapActions, mapGetters } from 'vuex';
import BaseLoadingBar from '@/components/base/BaseLoadingBar';
import DocumentKeywordsList from './DocumentKeywordsList.vue';

export default {
  name: 'DocumentKeywordsTable',
  components: {
    BaseLoadingBar,
    DocumentKeywordsList,
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('documentKeywords', ['keywords', 'pending']),
    isAdmin() {
      return isAdminTenant(this.currentUser.role);
    },
  },
  methods: {
    ...mapActions('documentKeywords', ['getKeywords']),
    async onRefreshKeywords() {
      await this.getKeywords();
    },
  },
  async created() {
    await this.getKeywords();
  },
};
</script>

<style lang="scss">
.page-document-keywords {
  width: 100%;
}
</style>
